import type { CustomerRole } from "../types/thalamos.js";

/**
 * The key a role-keyed table holds this role's row under; `none` is a guest's,
 * who holds no role anywhere.
 */
export const roleOrNone = (role: CustomerRole | null): CustomerRole | "none" =>
  role ?? "none";
